// Enum for trip request travel preference
export const TravelPreferenceType = Object.freeze({
  DEPART_AT: 'DEPART_AT',
  ARRIVE_BY: 'ARRIVE_BY'
});
